import { jsx as c, jsxs as w } from "react/jsx-runtime";
import { memo as R, useState as $, useMemo as j, useCallback as O, useEffect as V } from "react";
import { LoadingEnum as y, debounce as q } from "@perxis-auto/shared";
import { useForm as z } from "@perxis-auto/trade-in-sdk";
import { Form as I } from "@perxis-auto/ui-kit/lib/components/Form";
import { Row as B, Col as x } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Typography as G } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP_EVENTS as C } from "../../../shared/config/events.js";
import { eventService as M } from "../../../shared/lib/event/eventService.js";
import { Loader as H } from "../../../shared/ui/Loader/Loader.js";
const ie = R(function({ formId: p, schema: a, children: S }) {
  const { data: t, loading: b, actions: k } = z({ id: p }), { setFieldsValues: f, submitForm: h, setFieldsErrors: u } = k, _ = [y.Pending].includes(b), F = [y.Failed].includes(b), [A, E] = $(!1), [l] = I.useForm(), g = j(() => a.groups.flatMap((s) => s.fields).reduce(
    (s, r, i, n) => ({
      ...s,
      [r.id]: n.filter((o) => {
        var m;
        return !!((m = o.depends) != null && m.includes(r.id));
      }).map((o) => o.id)
    }),
    {}
  ), [a.groups]), D = (s) => {
    const r = a.groups.flatMap((i) => i.fields).filter((i) => i.type === "boolean");
    return Object.fromEntries(
      Object.entries(s).map(([i, n]) => r.find(({ id: o }) => o === i) ? [i, !!n] : [i, n])
    );
  }, L = O(
    (s) => {
      f(D(s)), h();
    },
    [f, h]
  ), N = O(
    ({ errorFields: s }) => {
      const r = Object.fromEntries(s.map((i) => [i.name[0], i.errors]));
      u(r);
    },
    [u]
  ), P = j(
    () => q((s, r) => {
      const i = Object.keys(s || {}), n = Array.from(
        new Set(i.flatMap((e) => g[e] || []))
      );
      for (const e of n) {
        const d = g[e];
        d != null && d.length && n.push(...d.filter((T) => !n.includes(T)));
      }
      const o = n.reduce((e, d) => ({ ...e, [d]: void 0 }), {});
      for (const e of Object.keys(s))
        M.sendEvent(C.FormFieldValueChanged, {
          formId: p,
          fieldId: e,
          value: s[e],
          previousValue: t == null ? void 0 : t.fields[e]
        });
      for (const e of Object.keys(o))
        t != null && t.fields[e] && M.sendEvent(C.FormFieldValueReset, {
          formId: p,
          fieldId: e,
          value: s[e],
          previousValue: t == null ? void 0 : t.fields[e]
        });
      const m = Object.fromEntries(
        Object.keys(r).map((e) => [e, l.getFieldError(e)]).filter(([, e]) => e.length)
      ), v = {
        ...r,
        ...o
      };
      E(!0), f(v), u(m), l.setFieldsValue(v);
    }, 300),
    [g, l, f, u, t]
  );
  if (V(() => {
    F && (l.resetFields(), E(!1));
  }, [l, F]), V(() => {
    t != null && t.fields && Object.keys(t.fields).length && l.validateFields();
  }, []), !!t)
    return _ ? /* @__PURE__ */ c(H, {}) : /* @__PURE__ */ w(B, { gutter: [0, "vertical-green"], className: "pa-trade-in-form", children: [
      !!a.text && /* @__PURE__ */ c(x, { span: 24, children: /* @__PURE__ */ c(G.Text, { className: "pa-trade-in-form__description", level: "main", color: "dark", children: a.text }) }),
      /* @__PURE__ */ c(x, { span: 24, children: /* @__PURE__ */ c(
        I,
        {
          initialValues: t.fields,
          form: l,
          onFinish: L,
          onFinishFailed: N,
          onValuesChange: P,
          children: S({ isDirty: A, isFailed: F })
        }
      ) })
    ] });
});
export {
  ie as Form
};
